// Accepts "VIC.csv" and names that carry the state as a separate token, e.g.
// "tblpropety_prices_sqm_vic.csv" — that VIC export staged 188,027 rows with no state (2026-09-26).
export function inferStateFromFileName(fileName: string): string | null {
  const match = fileName.toUpperCase().match(/(?:^|[^A-Z])(ACT|NSW|NT|QLD|SA|TAS|VIC|WA)\.CSV$/);
  return match?.[1] ?? null;
}
